
import { client } from "helpers/client"


export const get_addon_byId = (addonId) => {
    
    return client(`Addon/${addonId}`)
}

export const get_addon_price = (addonId,priceLevelId) => {
    
    return client(`Addon/Addon/${addonId}/${priceLevelId ?? ""}`)
}
